<script>
export default {
	props: ['project'],
	emits: ['open'],
};
</script>

<template>
	<div
		@click="$emit('open')"
		class="clip-corner-sm shadow-lg hover:shadow-glow overflow-hidden mb-10 sm:mb-0 bg-secondary-dark border border-ternary-dark group cursor-pointer duration-300"
	>
		<img
			:src="project.img"
			:alt="project.title"
			loading="lazy"
			class="w-full h-56 object-cover border-none duration-500 group-hover:scale-110"
		/>
	</div>
</template>

<style lang="scss" scoped></style>
